import React from 'react';
import EArchiveGroupActionsWrapper from '../EArchiveGroupActionsWrapper';
import { GroupActionItem } from '../../../../Interfaces/GroupActionItem.interface';

interface Props {
	onAddMembers: () => void;
	onRemoveMembers: () => void;
}

const EArchiveGroupMembersActions = ({
	onAddMembers,
	onRemoveMembers,
}: Props) => {
	const items: GroupActionItem[] = [
		{
			title: 'component.eArchive.group.members.addMembers',
			onClick: onAddMembers,
		},
		{
			title: 'component.eArchive.group.members.removeMembers',
			onClick: onRemoveMembers,
		},
	];

	return <EArchiveGroupActionsWrapper items={items} />;
};

export default EArchiveGroupMembersActions;
